import { Box, Grid } from "@mui/material";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./ingredients.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Ingredients = ({
  Ingredients1,
  Ingredients2,
  Ingredients3,
  Ingredients4,
  Ingredients5,
  Ingredients6,
  Ingredients7,
  Ingredients8,
}) => {
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "20px",
    slidesToShow: 1,
    speed: 1000,
    nextArrow: null,

    beforeChange: () => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    },
  };

  return (
    <div className="ingredients-container">
      <Grid
        container
        spacing={2}
        style={{ width: "100%" }}
        className="website-ingredients"
      >
        <Grid item xs={12} sm={12} md={8}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <div className="ingredient ingredient-1">
                <Box
                  component="img"
                  sx={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  src={Ingredients1.img}
                />
                <p>{Ingredients1.name}</p>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <div className="ingredient ingredient-2">
                <Box
                  component="img"
                  sx={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  src={Ingredients2.img}
                />
                <p>{Ingredients2.name}</p>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              <div className="ingredient ingredient-3">
                <Box
                  component="img"
                  sx={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  src={Ingredients3.img}
                />
                <p>{Ingredients3.name}</p>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ display: { md: "none" } }}>
          <div className="ingredient ingredient-3">
            <Box
              component="img"
              sx={{
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
              src={Ingredients3.img}
            />
            <p>{Ingredients3.name}</p>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <div className="ingredient ingredient-4">
            <Box
              component="img"
              sx={{
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
              src={Ingredients4.img}
            />
            <p>{Ingredients4.name}</p>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={5}>
          <div className="ingredient ingredient-5">
            <Box
              component="img"
              sx={{
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
              src={Ingredients5.img}
            />
            <p>{Ingredients5.name}</p>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={1.5}>
          <div className="ingredient ingredient-6">
            <Box
              component="img"
              sx={{
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
              src={Ingredients6.img}
            />
            <p>{Ingredients6.name}</p>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={2.5}>
          <div className="ingredient ingredient-7">
            <Box
              component="img"
              sx={{
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
              src={Ingredients7.img}
            />
            <p>{Ingredients7.name}</p>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="ingredient ingredient-8">
            <Box
              component="img"
              sx={{
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
              src={Ingredients8.img}
            />
            <p>{Ingredients8.name}</p>
          </div>
        </Grid>
      </Grid>

      {/* <div className="mobile-ingredients">
        <Swiper
          spaceBetween={30}
          autoplay={{ delay: 2000 }}
          loop={true}
          className="mySwiper"
        >
          {[
            Ingredients1,
            Ingredients2,
            Ingredients3,
            Ingredients4,
            Ingredients5,
            Ingredients6,
            Ingredients7,
            Ingredients8,
          ].map((Ingredients, index) => (
            <SwiperSlide key={index}>
              <div className={`ingredient ingredient-${index + 1}`}>
                <Box
                  component="img"
                  sx={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  src={Ingredients.img}
                />
                <div className="name-desc">
                  <div>
                    <p className="name">{Ingredients.name}</p>
                    <p className="desc">{Ingredients.desc}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div> */}

      <div className="mobile-ingredients">
        <Slider
          // autoplay={{
          //   delay: 3000,
          //   disableOnInteraction: false,
          // }}
          {...settings}
          className="mySwiper"
        >
          {[
            Ingredients1,
            Ingredients2,
            Ingredients3,
            Ingredients4,
            Ingredients5,
            Ingredients6,
            Ingredients7,
            Ingredients8,
          ].map((Ingredients, index) => (
            // <div
            //   className={`singleCarousel`}
            //   key={index}
            //   // onClick={() => onSideSwiperChange(index)}
            // >
            //   <img
            //     src={`${PRODUCT_IMAGE_URL}${img}`}
            //     alt={img + " - " + index}
            //   />
            // </div>
            <div key={index} className={`ingredient ingredient-${index + 1}`}>
              <Box
                component="img"
                sx={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
                src={Ingredients.img}
              />
              <div className="name-desc">
                <div>
                  <p className="name">{Ingredients.name}</p>
                  <p className="desc">{Ingredients.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Ingredients;
